import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/authContext';
import { useLocation, useNavigate } from 'react-router-dom';
import './../../components/auth.css';

const Login: React.FC = () => {
  const { login, isAuthenticated } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [autoLoginAttempted, setAutoLoginAttempted] = useState(false);
  
  // Get the return path from location state if it exists
  const from = location.state?.from?.pathname || '/';
  
  // If user is already authenticated, redirect them
  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  // Automatically attempt login when component mounts
  useEffect(() => {
    const attemptAutoLogin = async () => {
      try {
        login();
        setAutoLoginAttempted(true);
      } catch (error) {
        setAutoLoginAttempted(true);
      }
    };

    if (!isAuthenticated && !autoLoginAttempted) {
      attemptAutoLogin();
    }
  }, [isAuthenticated, login, autoLoginAttempted]);

  return (
    <div className="login-container">
      <h1>Kitchen Wizard</h1>
      <p>Please log in to access the application</p>
      {autoLoginAttempted ? (
        <p className="auto-login-message">Automatic login in progress. If you are not redirected automatically, please click the button below.</p>
      ) : (
        <p>Initiating automatic login...</p>
      )}
      <button 
        className="login-button" 
        onClick={() => login()}
      >
        Log In
      </button>
    </div>
  );
};

export default Login;